<template>
    <nav>
        <ul class="pagination mb-0">
            <li class="page-item">
                <a class="page-link" href="" aria-label="Previous" @click.prevent="$emit('toPage', page - 1)">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>

            <li v-if="page !== 1" class="page-item">
                <a class="page-link" href="" aria-label="First Page" @click.prevent="$emit('toPage', 1)">
                    1
                </a>
            </li>

            <li v-if="page > 3" class="page-item">
                <a class="page-link" href="" aria-label="Spacer">
                    <span aria-hidden="true">&hellip;</span>
                </a>
            </li>

            <li v-if="page > 2" class="page-item">
                <a class="page-link" href="" aria-label="Page Before" @click.prevent="$emit('toPage', page - 1)">
                    {{ page - 1 }}
                </a>
            </li>
            <li class="page-item active">
                <a class="page-link" href="" aria-label="Current">
                    {{ page }}
                </a>
            </li>
            <li v-if="pageCount - page > 1" class="page-item">
                <a class="page-link" href="" aria-label="Page After" @click.prevent="$emit('toPage', page + 1)">
                    {{ page + 1 }}
                </a>
            </li>

            <li v-if="pageCount - page > 2" class="page-item">
                <a class="page-link" href="" aria-label="Spacer">
                    <span aria-hidden="true">&hellip;</span>
                </a>
            </li>

            <li v-if="page !== pageCount" class="page-item">
                <a class="page-link" href="" aria-label="Last Page" @click.prevent="$emit('toPage', pageCount)">
                    {{ pageCount }}
                </a>
            </li>

            <li class="page-item">
                <a class="page-link" href="" aria-label="Next" @click.prevent="$emit('toPage', page + 1)">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        page: Number,
        pageSize: Number,
        total: Number,
    },
    computed: {
        pageCount() {
			return Math.ceil(this.total / this.pageSize);
		},
    }
}
</script>